import React from 'react';
import { connect } from 'react-redux';
import { t } from '../../../../../locales';
import { NewsButton } from '../NewsButton';
import {
  getLanguage,
  getCustomerContentoType,
} from '../../../../../selectors/userSelectors';
import {
  getAxaNews,
  getBlogArticles,
} from '../../../selectors/serviceSelectors';
import { getHomepageNewsApiUrl } from '../../../../../selectors/configSelectors';
import SeeAllNewsButton from '../SeeAllNewsButton';
import './styles.scss';
import { HomepageNewsConfig } from '../../../../../types/configTypes';
import { addCorpWebIndicator } from '../../../../../utils/emmaUrlConverter';
import { getCorpWebIndicatorConfig } from '../../../../emma-webview/selectors/webviewSelector';

const AxaNews: any = (props: {
  news: Array<any>;
  newsApiLink: HomepageNewsConfig;
  showAllUrl: string;
  blogArticles: any[];
  customerContentoType: string[];
}) => {
  const { news, newsApiLink, showAllUrl, blogArticles } = props;
  return (
    <div className="news-list__wrapper">
      <div className="news-list__title">{t('HOMEPAGE_HEALTH_NEWS_TITLE')}</div>
      {!!news && news.length > 0 && (
        <div className="news-list__content axa-news-list__content">
          {news.slice(0, 3).map((item) => (
            <NewsButton
              key={item.uid}
              newsId={item.uid}
              title={item.document_title}
              category={item.article_category}
              categoryLabel={item.article_category}
              thumbnail={item.header_image.views.thumb.url}
              deepLink={item.deepLink}
            />
          ))}
        </div>
      )}
      {!!blogArticles && blogArticles.length > 0 && (
        <div className="news-list__content axa-news-list__content">
          {blogArticles.slice(0, 3).map((item) => {
            const { uid, bannerTitle, categoryLabel, category, deepLink } =
              item;

            let thumbnail = '';
            try {
              thumbnail = item.image.banner.src;
            } catch (error) {
              console.warn(error);
              thumbnail = '';
            }

            return (
              <NewsButton
                key={uid}
                newsId={uid}
                title={bannerTitle}
                categoryLabel={categoryLabel}
                v2={true}
                category={category}
                thumbnail={thumbnail}
                deepLink={deepLink}
              />
            );
          })}
        </div>
      )}
      <SeeAllNewsButton title="HOMEPAGE_SHOW_ALL_NEWS" deepLink={showAllUrl} />
    </div>
  );
};

const mapStateToProps = (state: any) => {
  const newsApiLink: any = getHomepageNewsApiUrl(state);

  let news = getAxaNews(state);
  let blogArticles = getBlogArticles(state);

  let showAllUrl = '';

  if (newsApiLink) {
    showAllUrl = `${newsApiLink.newsBlogUrl}/${getLanguage()}/blog`;
  }

  const customerContentoType = getCustomerContentoType(state);

  if (news) {
    news = news.filter(
      (item: any) =>
        !item.profile || customerContentoType.includes(item.profile),
    );
    news.forEach((item: any) => {
      if (newsApiLink) {
        const url = `${newsApiLink.newsBlogUrl}/${getLanguage()}/blog/${
          item.article_category
        }/${item.slug}`;
        item.deepLink = addCorpWebIndicator({
          url,
          ...getCorpWebIndicatorConfig(state),
        });
      }
    });
  }

  if (blogArticles) {
    blogArticles = blogArticles.filter(
      (item: any) =>
        !item.profile || customerContentoType.includes(item.profile),
    );
    blogArticles.forEach((item: any) => {
      if (newsApiLink) {
        const url = `${newsApiLink.newsBlogUrl}/${getLanguage()}/blog/article/${
          item.uid
        }`;
        item.deepLink = addCorpWebIndicator({
          url,
          ...getCorpWebIndicatorConfig(state),
        });
      }
    });
  }

  if (newsApiLink) {
    showAllUrl = addCorpWebIndicator({
      url: showAllUrl,
      ...getCorpWebIndicatorConfig(state),
    });
  }

  return {
    news: news,
    blogArticles,
    newsApiLink: newsApiLink,
    showAllUrl: showAllUrl,
  };
};

export default connect(mapStateToProps, null)(AxaNews);
